// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.react-datepicker{
  width: 100%;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow,
.react-datepicker__navigation-icon::before {
    border-color: #ccc;
    border-style: solid;
    border-width: 2px 2px 0 0;
    content: '';
    display: block;
    height: 7px;
    position: absolute;
    top: 2px;
    width: 7px;
}

.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {
    margin-left: -4px;
    position: absolute;
    width: 0;
}

.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after,
.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {
    box-sizing: content-box;
    position: absolute;
    border: 8px solid transparent;
    height: 0;
    width: 1px;
    content: '';
    z-index: var(--zIndex-BASE-MINUS_1);
    left: -8px;
}

.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {
    border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {
    top: 0;
    margin-top: -8px;
}

.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {
    border-top: none;
    border-bottom-color: white;
}

.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {
    top: 0;
}

.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {
    top: -1px;
    border-bottom-color: var(--border-neutral-default);
}

.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {
    bottom: 0;
    margin-bottom: -8px;
}

.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after {
    border-bottom: none;
    border-top-color: #fff;
}

.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after {
    bottom: 0;
}

.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before {
    bottom: -1px;
    border-top-color: #aeaeae;
}

.react-datepicker-wrapper {
    display: inline-block;
    padding: 0;
    border: 0;
}

.react-datepicker {
    font-family: 'Helvetica Neue', helvetica, arial, sans-serif;
    font-size: 0.8rem;
    background-color: #fff;
    color: #000;
    border-radius: 0.3rem;
    display: inline-block;
    position: relative;
}

.react-datepicker--time-only .react-datepicker__triangle {
    left: 35px;
}

.react-datepicker--time-only .react-datepicker__time-container {
    border-left: 0;
}

.react-datepicker--time-only .react-datepicker__time,
.react-datepicker--time-only .react-datepicker__time-box {
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
}

.react-datepicker__triangle {
    position: absolute;
    left: 50px;
}

.react-datepicker-popper {
    z-index: var(--zIndex-BASE_10);
}

.react-datepicker-popper.react-datepicker-popper-hidden {
    display: none !important;
}

.react-datepicker-popper[data-placement^='bottom'] {
    padding-top: 10px;
}

.react-datepicker-popper[data-placement='bottom-end'] .react-datepicker__triangle,
.react-datepicker-popper[data-placement='top-end'] .react-datepicker__triangle {
    left: auto;
    right: 50px;
}

.react-datepicker-popper[data-placement^='top'] {
    padding-bottom: 10px;
}

.react-datepicker-popper[data-placement^='right'] {
    padding-left: 8px;
}

.react-datepicker-popper[data-placement^='right'] .react-datepicker__triangle {
    left: auto;
    right: 42px;
}

.react-datepicker-popper[data-placement^='left'] {
    padding-right: 8px;
}

.react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {
    left: 42px;
    right: auto;
}

.react-datepicker__header {
    text-align: center;
    padding: 8px 0;
    position: relative;
    color: var(--content-primary-primary);
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.react-datepicker__header--time {
    padding-bottom: 8px;
    padding-left: 5px;
    padding-right: 5px;
}

.react-datepicker__header--time:not(.react-datepicker__header--time--only) {
    border-top-left-radius: 0;
}

.react-datepicker__header:not(.react-datepicker__header--has-time-select) {
    border-top-right-radius: 0.3rem;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
    display: inline-block;
    margin: 0 15px;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
    color: var(--content-primary-primary);
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    height: 32px;
    line-height: 32px;
}

.react-datepicker-time__header {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.react-datepicker__navigation {
    align-items: center;
    background: none;
    display: flex;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 11px;
    padding: 0;
    border: none;
    z-index: var(--zIndex-BASE_1);
    height: 32px;
    width: 32px;
    text-indent: -999em;
    overflow: hidden;
}

.react-datepicker__navigation--previous {
    left: 2px;
}

.react-datepicker__navigation--next {
    right: 2px;
}

.react-datepicker__navigation--next--with-time:not(
    .react-datepicker__navigation--next--with-today-button
  ) {
    right: 85px;
}

.react-datepicker__navigation--years {
    position: relative;
    top: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.react-datepicker__navigation--years-previous {
    top: 4px;
}

.react-datepicker__navigation--years-upcoming {
    top: -4px;
}

.react-datepicker__navigation:hover *::before {
    border-color: #a6a6a6;
}

.react-datepicker__navigation-icon {
    position: relative;
    top: -1px;
    font-size: 14px;
    width: 0;
}

.react-datepicker__navigation-icon--next {
    left: -2px;
}

.react-datepicker__navigation-icon--next::before {
    transform: rotate(45deg);
    left: -7px;
}

.react-datepicker__navigation-icon--previous {
    right: -2px;
}

.react-datepicker__navigation-icon--previous::before {
    transform: rotate(225deg);
    right: -7px;
}

.react-datepicker__month-container {
    float: left;
}

.react-datepicker__year {
    margin: 0.4rem;
    text-align: center;
}

.react-datepicker__year-wrapper {
    display: flex;
    flex-wrap: wrap;
    max-width: 180px;
}

.react-datepicker__year .react-datepicker__year-text {
    display: inline-block;
    width: 4rem;
    margin: 2px;
}

.react-datepicker__month {
    margin: 0;
    text-align: center;
}

.react-datepicker__month .react-datepicker__month-text,
.react-datepicker__month .react-datepicker__quarter-text {
    display: inline-block;
    width: 4rem;
    margin: 2px;
}

.react-datepicker__input-time-container {
    clear: both;
    width: 100%;
    float: left;
    margin: 5px 0 10px 15px;
    text-align: left;
}

.react-datepicker__input-time-container .react-datepicker-time__caption {
    display: inline-block;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container {
    display: inline-block;
}

.react-datepicker__input-time-container
.react-datepicker-time__input-container
.react-datepicker-time__input {
    display: inline-block;
    margin-left: 10px;
}

.react-datepicker__input-time-container
.react-datepicker-time__input-container
.react-datepicker-time__input
input {
    width: auto;
}

.react-datepicker__input-time-container
.react-datepicker-time__input-container
.react-datepicker-time__input
input[type='time']::-webkit-inner-spin-button,
.react-datepicker__input-time-container
.react-datepicker-time__input-container
.react-datepicker-time__input
input[type='time']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.react-datepicker__input-time-container
.react-datepicker-time__input-container
.react-datepicker-time__input
input[type='time'] {
    -moz-appearance: textfield;
}

.react-datepicker__input-time-container
.react-datepicker-time__input-container
.react-datepicker-time__delimiter {
    margin-left: 5px;
    display: inline-block;
}

.react-datepicker__time-container {
    float: right;
    width: 85px;
}

.react-datepicker__time-container--with-today-button {
    display: inline;
    border-radius: 0.3rem;
    position: absolute;
    right: -87px;
    top: 0;
}

.react-datepicker__time-container .react-datepicker__time {
    position: relative;
    background: white;
    border-bottom-right-radius: 0.3rem;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
    width: 85px;
    overflow-x: hidden;
    margin: 0 auto;
    text-align: center;
    border-bottom-right-radius: 0.3rem;
}

.react-datepicker__time-container
.react-datepicker__time
.react-datepicker__time-box
ul.react-datepicker__time-list {
    list-style: none;
    margin: 0;
    height: calc(195px + 1.7rem / 2);
    overflow-y: scroll;
    padding-right: 0;
    padding-left: 0;
    width: 100%;
    box-sizing: content-box;
}

.react-datepicker__time-container
.react-datepicker__time
.react-datepicker__time-box
ul.react-datepicker__time-list
li.react-datepicker__time-list-item {
    height: 30px;
    padding: 5px 10px;
    white-space: nowrap;
}

.react-datepicker__time-container
.react-datepicker__time
.react-datepicker__time-box
ul.react-datepicker__time-list
li.react-datepicker__time-list-item:hover {
    cursor: pointer;
    background-color: #f0f0f0;
}

.react-datepicker__time-container
.react-datepicker__time
.react-datepicker__time-box
ul.react-datepicker__time-list
li.react-datepicker__time-list-item--selected {
    background-color: #216ba5;
    color: white;
    font-weight: bold;
}

.react-datepicker__time-container
.react-datepicker__time
.react-datepicker__time-box
ul.react-datepicker__time-list
li.react-datepicker__time-list-item--selected:hover {
    background-color: #216ba5;
}

.react-datepicker__time-container
.react-datepicker__time
.react-datepicker__time-box
ul.react-datepicker__time-list
li.react-datepicker__time-list-item--disabled {
    color: #ccc;
}

.react-datepicker__time-container
.react-datepicker__time
.react-datepicker__time-box
ul.react-datepicker__time-list
li.react-datepicker__time-list-item--disabled:hover {
    cursor: default;
    background-color: transparent;
}

.react-datepicker__week-number {
    color: #ccc;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable {
    cursor: pointer;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable:not(
    .react-datepicker__week-number--selected,
    .react-datepicker__week-number--keyboard-selected
  ):hover {
    border-radius: 0.3rem;
    background-color: #f0f0f0;
}

.react-datepicker__week-number--selected {
    border-radius: 0.3rem;
    background-color: #216ba5;
    color: #fff;
}

.react-datepicker__week-number--selected:hover {
    background-color: #1d5d90;
}

.react-datepicker__week-number--keyboard-selected {
    border-radius: 0.3rem;
    background-color: #2a87d0;
    color: #fff;
}

.react-datepicker__week-number--keyboard-selected:hover {
    background-color: #1d5d90;
}

.react-datepicker__week, .react-datepicker__day-names {
  white-space: nowrap;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}

.react-datepicker__day-names {
    margin-top: 8px;
    margin-bottom: -8px;
}

.react-datepicker__day-name,
.react-datepicker__time-name {
    display: inline-block;
    min-width: 40px;
    height: 32px;
    color: var(--content-neutral-primary);
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: 32px;
    letter-spacing: 0.2px;
}

.react-datepicker__day {
    min-width: 40px;
    height: 32px;
    display: inline-block;
    color: var(--content-primary-primary);
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    margin: 4px 0;
}

.react-datepicker__day,
.react-datepicker__month-text,
.react-datepicker__quarter-text,
.react-datepicker__year-text {
    cursor: pointer;
}

.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover,
.react-datepicker__year-text:hover {
    border-radius: 8px;
    background: var(--background-neutral-primary);
}

.react-datepicker__day--today,
.react-datepicker__month-text--today,
.react-datepicker__quarter-text--today,
.react-datepicker__year-text--today {
    font-weight: bold;
}

.react-datepicker__day--highlighted,
.react-datepicker__month-text--highlighted,
.react-datepicker__quarter-text--highlighted,
.react-datepicker__year-text--highlighted {
    border-radius: 0.3rem;
    background-color: #3dcc4a;
    color: #fff;
}

.react-datepicker__day--highlighted:hover,
.react-datepicker__month-text--highlighted:hover,
.react-datepicker__quarter-text--highlighted:hover,
.react-datepicker__year-text--highlighted:hover {
    background-color: #32be3f;
}

.react-datepicker__day--highlighted-custom-1,
.react-datepicker__month-text--highlighted-custom-1,
.react-datepicker__quarter-text--highlighted-custom-1,
.react-datepicker__year-text--highlighted-custom-1 {
    color: magenta;
}

.react-datepicker__day--highlighted-custom-2,
.react-datepicker__month-text--highlighted-custom-2,
.react-datepicker__quarter-text--highlighted-custom-2,
.react-datepicker__year-text--highlighted-custom-2 {
    color: green;
}

.react-datepicker__day--holidays,
.react-datepicker__month-text--holidays,
.react-datepicker__quarter-text--holidays,
.react-datepicker__year-text--holidays {
    position: relative;
    border-radius: 0.3rem;
    background-color: #ff6803;
    color: #fff;
}

.react-datepicker__day--holidays .holiday-overlay,
.react-datepicker__month-text--holidays .holiday-overlay,
.react-datepicker__quarter-text--holidays .holiday-overlay,
.react-datepicker__year-text--holidays .holiday-overlay {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 4px;
    border-radius: 4px;
    white-space: nowrap;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.3s ease-in-out;
}

.react-datepicker__day--holidays:hover,
.react-datepicker__month-text--holidays:hover,
.react-datepicker__quarter-text--holidays:hover,
.react-datepicker__year-text--holidays:hover {
    background-color: #cf5300;
}

.react-datepicker__day--holidays:hover .holiday-overlay,
.react-datepicker__month-text--holidays:hover .holiday-overlay,
.react-datepicker__quarter-text--holidays:hover .holiday-overlay,
.react-datepicker__year-text--holidays:hover .holiday-overlay {
    visibility: visible;
    opacity: 1;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
    border-radius: 0;
    background: var(--light-blue-a-15);
    margin: 4px 0;
    min-width: 40px;
    height: 32px;
}

.react-datepicker__day--selected:hover,
.react-datepicker__day--in-selecting-range:hover,
.react-datepicker__day--in-range:hover,
.react-datepicker__month-text--selected:hover,
.react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker__month-text--in-range:hover,
.react-datepicker__quarter-text--selected:hover,
.react-datepicker__quarter-text--in-selecting-range:hover,
.react-datepicker__quarter-text--in-range:hover,
.react-datepicker__year-text--selected:hover,
.react-datepicker__year-text--in-selecting-range:hover,
.react-datepicker__year-text--in-range:hover {
    background: var(--content-brand-primary);
    color: var(--light-blue-10);
    border-radius: 0;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
    /* border-radius: 0.3rem;
    background-color: #bad9f1;
    color: rgb(0, 0, 0); */
}

.react-datepicker__day--keyboard-selected:hover,
.react-datepicker__month-text--keyboard-selected:hover,
.react-datepicker__quarter-text--keyboard-selected:hover,
.react-datepicker__year-text--keyboard-selected:hover {
    background: var(--content-brand-primary);
    color: var(--light-blue-10);
    border-radius: 0;
}

.react-datepicker__day--in-selecting-range:not(
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--in-range
  ),
.react-datepicker__month-text--in-selecting-range:not(
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--in-range
  ),
.react-datepicker__quarter-text--in-selecting-range:not(
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--in-range
  ),
.react-datepicker__year-text--in-selecting-range:not(
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--in-range
  ) {
    background-color: rgba(33, 107, 165, 0.5);
}

.react-datepicker__month--selecting-range
.react-datepicker__day--in-range:not(
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__year-text--in-selecting-range
  ),
.react-datepicker__year--selecting-range
.react-datepicker__day--in-range:not(
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__year-text--in-selecting-range
  ),
.react-datepicker__month--selecting-range
.react-datepicker__month-text--in-range:not(
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__year-text--in-selecting-range
  ),
.react-datepicker__year--selecting-range
.react-datepicker__month-text--in-range:not(
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__year-text--in-selecting-range
  ),
.react-datepicker__month--selecting-range
.react-datepicker__quarter-text--in-range:not(
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__year-text--in-selecting-range
  ),
.react-datepicker__year--selecting-range
.react-datepicker__quarter-text--in-range:not(
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__year-text--in-selecting-range
  ),
.react-datepicker__month--selecting-range
.react-datepicker__year-text--in-range:not(
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__year-text--in-selecting-range
  ),
.react-datepicker__year--selecting-range
.react-datepicker__year-text--in-range:not(
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__year-text--in-selecting-range
  ) {
    background-color: #f0f0f0;
    color: #000;
}

.react-datepicker__day--disabled,
.react-datepicker__month-text--disabled,
.react-datepicker__quarter-text--disabled,
.react-datepicker__year-text--disabled {
    cursor: default;
    color: #ccc;
}

.react-datepicker__day--disabled:hover,
.react-datepicker__month-text--disabled:hover,
.react-datepicker__quarter-text--disabled:hover,
.react-datepicker__year-text--disabled:hover {
    background-color: transparent;
}

.react-datepicker__day.react-datepicker__day--in-selecting-range:hover {
    background: var(--background-neutral-primary);
    color: var(--content-primary-primary);
}

.react-datepicker__day.react-datepicker__day--in-selecting-range {
    border-radius: 0;
    background: var(--light-blue-a-15);
}

.react-datepicker__day.react-datepicker__day--today {
    border-radius: 8px;
    border: 1px solid var(--border-neutral-default);
    background: var(--background-primary-inverted-primary);
    color: var(--content-brand-primary);
}

.react-datepicker__day.react-datepicker__day--range-start,
.react-datepicker__day.react-datepicker__day--selecting-range-start,
.react-datepicker__day.react-datepicker__day--selecting-range-start:hover {
    background: var(--content-brand-primary);
    color: var(--light-blue-10);
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
}

.react-datepicker__day.react-datepicker__day--range-end,
.react-datepicker__day.react-datepicker__day--selecting-range-end,
.react-datepicker__day.react-datepicker__day--selecting-range-end:hover {
    background: var(--content-brand-primary);
    color: var(--light-blue-10);
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
}

.react-datepicker__aria-live + .react-datepicker__month-container {
    padding-right: 12px;
    margin-right: 12px;
    border-right: 1px #e9ebec solid;
}

.react-datepicker__month-container {
    padding-bottom: 8px;
}

.react-datepicker__day--outside-month,
.react-datepicker__day--outside-month:hover,
.react-datepicker__day--outside-month.react-datepicker__day--in-selecting-range {
    height: 0;
    overflow: hidden;
}

.react-datepicker__input-container {
    position: relative;
    display: inline-block;
    width: 100%;
}

.react-datepicker__input-container .react-datepicker__calendar-icon {
    position: absolute;
    padding: 0.5rem;
    box-sizing: content-box;
    border-radius: 6px;
    fill: var(--content-primary-tertiary);
}

.react-datepicker__input-container .react-datepicker__calendar-icon path {
    fill: var(--content-primary-tertiary);
}

.react-datepicker__view-calendar-icon input {
    padding: 6px 10px 5px 25px;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
    border: 1px solid transparent;
    border-radius: 0.3rem;
    position: relative;
}

.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
    cursor: pointer;
}

.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
    border-top-color: #b3b3b3;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
    transform: rotate(135deg);
    right: -16px;
    top: 0;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
    background-color: #f0f0f0;
    position: absolute;
    width: 50%;
    left: 25%;
    top: 30px;
    z-index: var(--zIndex-BASE_1);
    text-align: center;
    border-radius: 0.3rem;
}

.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
    cursor: pointer;
}

.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
    height: 150px;
    overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
    line-height: 20px;
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
}

.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
    background-color: #ccc;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
    border-bottom-color: #b3b3b3;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
    border-top-color: #b3b3b3;
}

.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
    position: absolute;
    left: 15px;
}

.react-datepicker__close-icon {
    cursor: pointer;
    background-color: transparent;
    border: 0;
    outline: 0;
    padding: 0;
    position: absolute;
    right: 4px;
    height: 24px;
    width: 24px;
    top: 4px;
    z-index: var(--zIndex-BASE-MINUS_1);
    vertical-align: middle;
    display: table-cell;
}

.react-datepicker__close-icon::after {
    cursor: pointer;
    color: var(--content-primary-tertiary);
    background-color: transparent;
    height: 22px;
    width: 24px;
    font-size: 16px;
    line-height: 1;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding-bottom: 2px;
    border-radius: 6px;
    content: '×';
}

.react-datepicker__close-icon:hover::after {
    color: var(--content-brand-secondary);
    background: var(--light-blue-20);
}

.react-datepicker__input-container input:focus-visible + .react-datepicker__close-icon,
.react-datepicker__input-container input:hover + .react-datepicker__close-icon,
.react-datepicker__input-container input:focus + .react-datepicker__close-icon,
.react-datepicker__close-icon:hover {
    z-index: var(--zIndex-BASE_1);
}

.react-datepicker__close-icon--disabled {
    cursor: default;
}

.react-datepicker__close-icon--disabled::after {
    cursor: default;
    background-color: #ccc;
}

.react-datepicker__today-button {
    background: #f0f0f0;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    padding: 5px 0;
    clear: left;
}

.react-datepicker__portal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 2147483647;
}

.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
    width: 3rem;
    line-height: 3rem;
}

@media (max-width: 400px), (max-height: 550px) {
    .react-datepicker__portal .react-datepicker__day-name,
    .react-datepicker__portal .react-datepicker__day,
    .react-datepicker__portal .react-datepicker__time-name {
        width: 2rem;
        line-height: 2rem;
    }
}

.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
    font-size: 1.44rem;
}

.react-datepicker__children-container {
    width: 13.8rem;
    margin: 0.4rem;
    padding-right: 0.2rem;
    padding-left: 0.2rem;
    height: auto;
}

.react-datepicker__aria-live {
    position: absolute;
    clip-path: circle(0);
    border: 0;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    width: 1px;
    white-space: nowrap;
}

.react-datepicker__calendar-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.125em;
}
`, "",{"version":3,"sources":["webpack://./src/shared/ui/DatePicker/ui/react-datepicker.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,WAAW;AACb;;AAEA;;;;IAII,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;;;;IAII,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;IACT,UAAU;IACV,WAAW;IACX,mCAAmC;IACnC,UAAU;AACd;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,MAAM;IACN,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;IACT,kDAAkD;AACtD;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,2DAA2D;IAC3D,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;;;;;IAMI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;;IAGI,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;;;IAGI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;IACrB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;;;IAII,WAAW;AACf;;AAEA;;;;;;;;IAQI,wBAAwB;IACxB,SAAS;AACb;;AAEA;;;;IAII,0BAA0B;AAC9B;;AAEA;;;IAGI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;;;;IAII,gBAAgB;IAChB,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,uBAAuB;AAC3B;;AAEA;;;;;IAKI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;;;;IAKI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;;;;IAKI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;;;;IAKI,yBAAyB;AAC7B;;AAEA;;;;;IAKI,WAAW;AACf;;AAEA;;;;;IAKI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;IAII,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qCAAqC;AACvC;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;;;;IAII,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;;;;IAII,iBAAiB;AACrB;;AAEA;;;;IAII,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;AACf;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;;;;IAII,YAAY;AAChB;;AAEA;;;;IAII,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;AACf;;AAEA;;;;IAII,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mDAAmD;AACvD;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;;;IAII,mBAAmB;IACnB,UAAU;AACd;;AAEA;;;;;;;;;;;;IAYI,gBAAgB;IAChB,kCAAkC;IAClC,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA;;;;;;;;;;;;IAYI,wCAAwC;IACxC,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;;;;IAII;;0BAEsB;AAC1B;;AAEA;;;;IAII,wCAAwC;IACxC,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;IAwBI,yCAAyC;AAC7C;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAwDI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;;;IAII,eAAe;IACf,WAAW;AACf;;AAEA;;;;IAII,6BAA6B;AACjC;;AAEA;IACI,6CAA6C;IAC7C,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,sDAAsD;IACtD,mCAAmC;AACvC;;AAEA;;;IAGI,wCAAwC;IACxC,2BAA2B;IAC3B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;;;IAGI,wCAAwC;IACxC,2BAA2B;IAC3B,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;IAGI,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;;;;;;IAMI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;IACzB,YAAY;IACZ,MAAM;AACV;;AAEA;;;IAGI,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;;;IAGI,aAAa;IACb,kBAAkB;AACtB;;AAEA;;;IAGI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;IAGI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;;IAGI,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;;IAGI,4BAA4B;AAChC;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;;IAGI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,SAAS;IACT,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,mCAAmC;IACnC,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;;;;IAII,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,OAAO;IACP,MAAM;IACN,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;IAGI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;;;QAGI,WAAW;QACX,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,wBAAwB;AAC5B","sourcesContent":["@charset \"UTF-8\";\n.react-datepicker{\n  width: 100%;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow,\n.react-datepicker__navigation-icon::before {\n    border-color: #ccc;\n    border-style: solid;\n    border-width: 2px 2px 0 0;\n    content: '';\n    display: block;\n    height: 7px;\n    position: absolute;\n    top: 2px;\n    width: 7px;\n}\n\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {\n    margin-left: -4px;\n    position: absolute;\n    width: 0;\n}\n\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after,\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {\n    box-sizing: content-box;\n    position: absolute;\n    border: 8px solid transparent;\n    height: 0;\n    width: 1px;\n    content: '';\n    z-index: var(--zIndex-BASE-MINUS_1);\n    left: -8px;\n}\n\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {\n    border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {\n    top: 0;\n    margin-top: -8px;\n}\n\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {\n    border-top: none;\n    border-bottom-color: white;\n}\n\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {\n    top: 0;\n}\n\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {\n    top: -1px;\n    border-bottom-color: var(--border-neutral-default);\n}\n\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {\n    bottom: 0;\n    margin-bottom: -8px;\n}\n\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after {\n    border-bottom: none;\n    border-top-color: #fff;\n}\n\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after {\n    bottom: 0;\n}\n\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before {\n    bottom: -1px;\n    border-top-color: #aeaeae;\n}\n\n.react-datepicker-wrapper {\n    display: inline-block;\n    padding: 0;\n    border: 0;\n}\n\n.react-datepicker {\n    font-family: 'Helvetica Neue', helvetica, arial, sans-serif;\n    font-size: 0.8rem;\n    background-color: #fff;\n    color: #000;\n    border-radius: 0.3rem;\n    display: inline-block;\n    position: relative;\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n    left: 35px;\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n    border-left: 0;\n}\n\n.react-datepicker--time-only .react-datepicker__time,\n.react-datepicker--time-only .react-datepicker__time-box {\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n    position: absolute;\n    left: 50px;\n}\n\n.react-datepicker-popper {\n    z-index: var(--zIndex-BASE_10);\n}\n\n.react-datepicker-popper.react-datepicker-popper-hidden {\n    display: none !important;\n}\n\n.react-datepicker-popper[data-placement^='bottom'] {\n    padding-top: 10px;\n}\n\n.react-datepicker-popper[data-placement='bottom-end'] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement='top-end'] .react-datepicker__triangle {\n    left: auto;\n    right: 50px;\n}\n\n.react-datepicker-popper[data-placement^='top'] {\n    padding-bottom: 10px;\n}\n\n.react-datepicker-popper[data-placement^='right'] {\n    padding-left: 8px;\n}\n\n.react-datepicker-popper[data-placement^='right'] .react-datepicker__triangle {\n    left: auto;\n    right: 42px;\n}\n\n.react-datepicker-popper[data-placement^='left'] {\n    padding-right: 8px;\n}\n\n.react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {\n    left: 42px;\n    right: auto;\n}\n\n.react-datepicker__header {\n    text-align: center;\n    padding: 8px 0;\n    position: relative;\n    color: var(--content-primary-primary);\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.react-datepicker__header--time {\n    padding-bottom: 8px;\n    padding-left: 5px;\n    padding-right: 5px;\n}\n\n.react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n    border-top-left-radius: 0;\n}\n\n.react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n    border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n    display: inline-block;\n    margin: 0 15px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n    color: var(--content-primary-primary);\n    text-align: center;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 500;\n    height: 32px;\n    line-height: 32px;\n}\n\n.react-datepicker-time__header {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.react-datepicker__navigation {\n    align-items: center;\n    background: none;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    cursor: pointer;\n    position: absolute;\n    top: 11px;\n    padding: 0;\n    border: none;\n    z-index: var(--zIndex-BASE_1);\n    height: 32px;\n    width: 32px;\n    text-indent: -999em;\n    overflow: hidden;\n}\n\n.react-datepicker__navigation--previous {\n    left: 2px;\n}\n\n.react-datepicker__navigation--next {\n    right: 2px;\n}\n\n.react-datepicker__navigation--next--with-time:not(\n    .react-datepicker__navigation--next--with-today-button\n  ) {\n    right: 85px;\n}\n\n.react-datepicker__navigation--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.react-datepicker__navigation--years-previous {\n    top: 4px;\n}\n\n.react-datepicker__navigation--years-upcoming {\n    top: -4px;\n}\n\n.react-datepicker__navigation:hover *::before {\n    border-color: #a6a6a6;\n}\n\n.react-datepicker__navigation-icon {\n    position: relative;\n    top: -1px;\n    font-size: 14px;\n    width: 0;\n}\n\n.react-datepicker__navigation-icon--next {\n    left: -2px;\n}\n\n.react-datepicker__navigation-icon--next::before {\n    transform: rotate(45deg);\n    left: -7px;\n}\n\n.react-datepicker__navigation-icon--previous {\n    right: -2px;\n}\n\n.react-datepicker__navigation-icon--previous::before {\n    transform: rotate(225deg);\n    right: -7px;\n}\n\n.react-datepicker__month-container {\n    float: left;\n}\n\n.react-datepicker__year {\n    margin: 0.4rem;\n    text-align: center;\n}\n\n.react-datepicker__year-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    max-width: 180px;\n}\n\n.react-datepicker__year .react-datepicker__year-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n}\n\n.react-datepicker__month {\n    margin: 0;\n    text-align: center;\n}\n\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n    clear: both;\n    width: 100%;\n    float: left;\n    margin: 5px 0 10px 15px;\n    text-align: left;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n    display: inline-block;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n    display: inline-block;\n}\n\n.react-datepicker__input-time-container\n.react-datepicker-time__input-container\n.react-datepicker-time__input {\n    display: inline-block;\n    margin-left: 10px;\n}\n\n.react-datepicker__input-time-container\n.react-datepicker-time__input-container\n.react-datepicker-time__input\ninput {\n    width: auto;\n}\n\n.react-datepicker__input-time-container\n.react-datepicker-time__input-container\n.react-datepicker-time__input\ninput[type='time']::-webkit-inner-spin-button,\n.react-datepicker__input-time-container\n.react-datepicker-time__input-container\n.react-datepicker-time__input\ninput[type='time']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.react-datepicker__input-time-container\n.react-datepicker-time__input-container\n.react-datepicker-time__input\ninput[type='time'] {\n    -moz-appearance: textfield;\n}\n\n.react-datepicker__input-time-container\n.react-datepicker-time__input-container\n.react-datepicker-time__delimiter {\n    margin-left: 5px;\n    display: inline-block;\n}\n\n.react-datepicker__time-container {\n    float: right;\n    width: 85px;\n}\n\n.react-datepicker__time-container--with-today-button {\n    display: inline;\n    border-radius: 0.3rem;\n    position: absolute;\n    right: -87px;\n    top: 0;\n}\n\n.react-datepicker__time-container .react-datepicker__time {\n    position: relative;\n    background: white;\n    border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n    width: 85px;\n    overflow-x: hidden;\n    margin: 0 auto;\n    text-align: center;\n    border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__time-container\n.react-datepicker__time\n.react-datepicker__time-box\nul.react-datepicker__time-list {\n    list-style: none;\n    margin: 0;\n    height: calc(195px + 1.7rem / 2);\n    overflow-y: scroll;\n    padding-right: 0;\n    padding-left: 0;\n    width: 100%;\n    box-sizing: content-box;\n}\n\n.react-datepicker__time-container\n.react-datepicker__time\n.react-datepicker__time-box\nul.react-datepicker__time-list\nli.react-datepicker__time-list-item {\n    height: 30px;\n    padding: 5px 10px;\n    white-space: nowrap;\n}\n\n.react-datepicker__time-container\n.react-datepicker__time\n.react-datepicker__time-box\nul.react-datepicker__time-list\nli.react-datepicker__time-list-item:hover {\n    cursor: pointer;\n    background-color: #f0f0f0;\n}\n\n.react-datepicker__time-container\n.react-datepicker__time\n.react-datepicker__time-box\nul.react-datepicker__time-list\nli.react-datepicker__time-list-item--selected {\n    background-color: #216ba5;\n    color: white;\n    font-weight: bold;\n}\n\n.react-datepicker__time-container\n.react-datepicker__time\n.react-datepicker__time-box\nul.react-datepicker__time-list\nli.react-datepicker__time-list-item--selected:hover {\n    background-color: #216ba5;\n}\n\n.react-datepicker__time-container\n.react-datepicker__time\n.react-datepicker__time-box\nul.react-datepicker__time-list\nli.react-datepicker__time-list-item--disabled {\n    color: #ccc;\n}\n\n.react-datepicker__time-container\n.react-datepicker__time\n.react-datepicker__time-box\nul.react-datepicker__time-list\nli.react-datepicker__time-list-item--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n}\n\n.react-datepicker__week-number {\n    color: #ccc;\n    display: inline-block;\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    margin: 0.166rem;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n    cursor: pointer;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable:not(\n    .react-datepicker__week-number--selected,\n    .react-datepicker__week-number--keyboard-selected\n  ):hover {\n    border-radius: 0.3rem;\n    background-color: #f0f0f0;\n}\n\n.react-datepicker__week-number--selected {\n    border-radius: 0.3rem;\n    background-color: #216ba5;\n    color: #fff;\n}\n\n.react-datepicker__week-number--selected:hover {\n    background-color: #1d5d90;\n}\n\n.react-datepicker__week-number--keyboard-selected {\n    border-radius: 0.3rem;\n    background-color: #2a87d0;\n    color: #fff;\n}\n\n.react-datepicker__week-number--keyboard-selected:hover {\n    background-color: #1d5d90;\n}\n\n.react-datepicker__week, .react-datepicker__day-names {\n  white-space: nowrap;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n}\n\n.react-datepicker__day-names {\n    margin-top: 8px;\n    margin-bottom: -8px;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__time-name {\n    display: inline-block;\n    min-width: 40px;\n    height: 32px;\n    color: var(--content-neutral-primary);\n    text-align: center;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 450;\n    line-height: 32px;\n    letter-spacing: 0.2px;\n}\n\n.react-datepicker__day {\n    min-width: 40px;\n    height: 32px;\n    display: inline-block;\n    color: var(--content-primary-primary);\n    text-align: center;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 32px;\n    margin: 4px 0;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text {\n    cursor: pointer;\n}\n\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover,\n.react-datepicker__year-text:hover {\n    border-radius: 8px;\n    background: var(--background-neutral-primary);\n}\n\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n    font-weight: bold;\n}\n\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted,\n.react-datepicker__year-text--highlighted {\n    border-radius: 0.3rem;\n    background-color: #3dcc4a;\n    color: #fff;\n}\n\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover,\n.react-datepicker__year-text--highlighted:hover {\n    background-color: #32be3f;\n}\n\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1,\n.react-datepicker__year-text--highlighted-custom-1 {\n    color: magenta;\n}\n\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2,\n.react-datepicker__year-text--highlighted-custom-2 {\n    color: green;\n}\n\n.react-datepicker__day--holidays,\n.react-datepicker__month-text--holidays,\n.react-datepicker__quarter-text--holidays,\n.react-datepicker__year-text--holidays {\n    position: relative;\n    border-radius: 0.3rem;\n    background-color: #ff6803;\n    color: #fff;\n}\n\n.react-datepicker__day--holidays .holiday-overlay,\n.react-datepicker__month-text--holidays .holiday-overlay,\n.react-datepicker__quarter-text--holidays .holiday-overlay,\n.react-datepicker__year-text--holidays .holiday-overlay {\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: #333;\n    color: #fff;\n    padding: 4px;\n    border-radius: 4px;\n    white-space: nowrap;\n    visibility: hidden;\n    opacity: 0;\n    transition: visibility 0s, opacity 0.3s ease-in-out;\n}\n\n.react-datepicker__day--holidays:hover,\n.react-datepicker__month-text--holidays:hover,\n.react-datepicker__quarter-text--holidays:hover,\n.react-datepicker__year-text--holidays:hover {\n    background-color: #cf5300;\n}\n\n.react-datepicker__day--holidays:hover .holiday-overlay,\n.react-datepicker__month-text--holidays:hover .holiday-overlay,\n.react-datepicker__quarter-text--holidays:hover .holiday-overlay,\n.react-datepicker__year-text--holidays:hover .holiday-overlay {\n    visibility: visible;\n    opacity: 1;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n    border-radius: 0;\n    background: var(--light-blue-a-15);\n    margin: 4px 0;\n    min-width: 40px;\n    height: 32px;\n}\n\n.react-datepicker__day--selected:hover,\n.react-datepicker__day--in-selecting-range:hover,\n.react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n    background: var(--content-brand-primary);\n    color: var(--light-blue-10);\n    border-radius: 0;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n    /* border-radius: 0.3rem;\n    background-color: #bad9f1;\n    color: rgb(0, 0, 0); */\n}\n\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover,\n.react-datepicker__year-text--keyboard-selected:hover {\n    background: var(--content-brand-primary);\n    color: var(--light-blue-10);\n    border-radius: 0;\n}\n\n.react-datepicker__day--in-selecting-range:not(\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-range\n  ),\n.react-datepicker__month-text--in-selecting-range:not(\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-range\n  ),\n.react-datepicker__quarter-text--in-selecting-range:not(\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-range\n  ),\n.react-datepicker__year-text--in-selecting-range:not(\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-range\n  ) {\n    background-color: rgba(33, 107, 165, 0.5);\n}\n\n.react-datepicker__month--selecting-range\n.react-datepicker__day--in-range:not(\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__year-text--in-selecting-range\n  ),\n.react-datepicker__year--selecting-range\n.react-datepicker__day--in-range:not(\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__year-text--in-selecting-range\n  ),\n.react-datepicker__month--selecting-range\n.react-datepicker__month-text--in-range:not(\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__year-text--in-selecting-range\n  ),\n.react-datepicker__year--selecting-range\n.react-datepicker__month-text--in-range:not(\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__year-text--in-selecting-range\n  ),\n.react-datepicker__month--selecting-range\n.react-datepicker__quarter-text--in-range:not(\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__year-text--in-selecting-range\n  ),\n.react-datepicker__year--selecting-range\n.react-datepicker__quarter-text--in-range:not(\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__year-text--in-selecting-range\n  ),\n.react-datepicker__month--selecting-range\n.react-datepicker__year-text--in-range:not(\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__year-text--in-selecting-range\n  ),\n.react-datepicker__year--selecting-range\n.react-datepicker__year-text--in-range:not(\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__year-text--in-selecting-range\n  ) {\n    background-color: #f0f0f0;\n    color: #000;\n}\n\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled,\n.react-datepicker__year-text--disabled {\n    cursor: default;\n    color: #ccc;\n}\n\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover,\n.react-datepicker__year-text--disabled:hover {\n    background-color: transparent;\n}\n\n.react-datepicker__day.react-datepicker__day--in-selecting-range:hover {\n    background: var(--background-neutral-primary);\n    color: var(--content-primary-primary);\n}\n\n.react-datepicker__day.react-datepicker__day--in-selecting-range {\n    border-radius: 0;\n    background: var(--light-blue-a-15);\n}\n\n.react-datepicker__day.react-datepicker__day--today {\n    border-radius: 8px;\n    border: 1px solid var(--border-neutral-default);\n    background: var(--background-primary-inverted-primary);\n    color: var(--content-brand-primary);\n}\n\n.react-datepicker__day.react-datepicker__day--range-start,\n.react-datepicker__day.react-datepicker__day--selecting-range-start,\n.react-datepicker__day.react-datepicker__day--selecting-range-start:hover {\n    background: var(--content-brand-primary);\n    color: var(--light-blue-10);\n    border-bottom-left-radius: 8px;\n    border-top-left-radius: 8px;\n}\n\n.react-datepicker__day.react-datepicker__day--range-end,\n.react-datepicker__day.react-datepicker__day--selecting-range-end,\n.react-datepicker__day.react-datepicker__day--selecting-range-end:hover {\n    background: var(--content-brand-primary);\n    color: var(--light-blue-10);\n    border-bottom-right-radius: 8px;\n    border-top-right-radius: 8px;\n}\n\n.react-datepicker__aria-live + .react-datepicker__month-container {\n    padding-right: 12px;\n    margin-right: 12px;\n    border-right: 1px #e9ebec solid;\n}\n\n.react-datepicker__month-container {\n    padding-bottom: 8px;\n}\n\n.react-datepicker__day--outside-month,\n.react-datepicker__day--outside-month:hover,\n.react-datepicker__day--outside-month.react-datepicker__day--in-selecting-range {\n    height: 0;\n    overflow: hidden;\n}\n\n.react-datepicker__input-container {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n}\n\n.react-datepicker__input-container .react-datepicker__calendar-icon {\n    position: absolute;\n    padding: 0.5rem;\n    box-sizing: content-box;\n    border-radius: 6px;\n    fill: var(--content-primary-tertiary);\n}\n\n.react-datepicker__input-container .react-datepicker__calendar-icon path {\n    fill: var(--content-primary-tertiary);\n}\n\n.react-datepicker__view-calendar-icon input {\n    padding: 6px 10px 5px 25px;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n    border: 1px solid transparent;\n    border-radius: 0.3rem;\n    position: relative;\n}\n\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n    cursor: pointer;\n}\n\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n    border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n    transform: rotate(135deg);\n    right: -16px;\n    top: 0;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n    background-color: #f0f0f0;\n    position: absolute;\n    width: 50%;\n    left: 25%;\n    top: 30px;\n    z-index: var(--zIndex-BASE_1);\n    text-align: center;\n    border-radius: 0.3rem;\n}\n\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n    cursor: pointer;\n}\n\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n    height: 150px;\n    overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n    line-height: 20px;\n    width: 100%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n    background-color: #ccc;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n    border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n    border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n    position: absolute;\n    left: 15px;\n}\n\n.react-datepicker__close-icon {\n    cursor: pointer;\n    background-color: transparent;\n    border: 0;\n    outline: 0;\n    padding: 0;\n    position: absolute;\n    right: 4px;\n    height: 24px;\n    width: 24px;\n    top: 4px;\n    z-index: var(--zIndex-BASE-MINUS_1);\n    vertical-align: middle;\n    display: table-cell;\n}\n\n.react-datepicker__close-icon::after {\n    cursor: pointer;\n    color: var(--content-primary-tertiary);\n    background-color: transparent;\n    height: 22px;\n    width: 24px;\n    font-size: 16px;\n    line-height: 1;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle;\n    padding-bottom: 2px;\n    border-radius: 6px;\n    content: '×';\n}\n\n.react-datepicker__close-icon:hover::after {\n    color: var(--content-brand-secondary);\n    background: var(--light-blue-20);\n}\n\n.react-datepicker__input-container input:focus-visible + .react-datepicker__close-icon,\n.react-datepicker__input-container input:hover + .react-datepicker__close-icon,\n.react-datepicker__input-container input:focus + .react-datepicker__close-icon,\n.react-datepicker__close-icon:hover {\n    z-index: var(--zIndex-BASE_1);\n}\n\n.react-datepicker__close-icon--disabled {\n    cursor: default;\n}\n\n.react-datepicker__close-icon--disabled::after {\n    cursor: default;\n    background-color: #ccc;\n}\n\n.react-datepicker__today-button {\n    background: #f0f0f0;\n    cursor: pointer;\n    text-align: center;\n    font-weight: bold;\n    padding: 5px 0;\n    clear: left;\n}\n\n.react-datepicker__portal {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.8);\n    left: 0;\n    top: 0;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    z-index: 2147483647;\n}\n\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n}\n\n@media (max-width: 400px), (max-height: 550px) {\n    .react-datepicker__portal .react-datepicker__day-name,\n    .react-datepicker__portal .react-datepicker__day,\n    .react-datepicker__portal .react-datepicker__time-name {\n        width: 2rem;\n        line-height: 2rem;\n    }\n}\n\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n    font-size: 1.44rem;\n}\n\n.react-datepicker__children-container {\n    width: 13.8rem;\n    margin: 0.4rem;\n    padding-right: 0.2rem;\n    padding-left: 0.2rem;\n    height: auto;\n}\n\n.react-datepicker__aria-live {\n    position: absolute;\n    clip-path: circle(0);\n    border: 0;\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    width: 1px;\n    white-space: nowrap;\n}\n\n.react-datepicker__calendar-icon {\n    width: 1em;\n    height: 1em;\n    vertical-align: -0.125em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
